import { PulseFilters, pulseFiltersSchema } from './types'

import { api } from 'api'
import { z } from 'zod'

const shiftNoticeMetricsResponse = z.object({
  average_hours_notice: z.number().nullable().optional(),
  short_notice_rate: z.number().nullable().optional(),
})

export type ShiftNoticeMetrics = z.infer<typeof shiftNoticeMetricsResponse>

export async function getShiftNoticeMetrics(
  filters: PulseFilters,
  signal?: AbortSignal
) {
  const data = pulseFiltersSchema.parse(filters)

  return await api
    .post('/company/pulse/operations/shift_notice_metrics', data, { signal })
    .then((response) => response.data)
    .then(shiftNoticeMetricsResponse.parse)
}
